<template>
    <div
        v-for="(answer, key) in props.content.answers"
        :key="key"
        class="question-row question-row-button"
        :data-lead-service-name="props.content.lead_service_name.value || `extradata-question-${props.index}`"
    >
        <button
            class="question-button-next button"
            type="button"
            :value="answer.ELMO_value.value"
            :data-showstopper="answer.showstopper.value"
            :data-hide-showstopper-close-button="answer.showstopper.hide_showstopper_close_button || false"
            :data-question-to="answer.next_question?.value"
            :data-linked-form-input="answer.linked_form_input && answer.linked_form_input.value"
            :data-worktype-id="answer.worktype_id_override?.value"
            :data-enquiry-dashboard-redirect-version="answer.enquiry_dashboard_redirect_version?.value"
            :data-label="stripHtml(answer.label.value)"
            data-answer
            :style="generateIndividualButtonVariables(answer)"
            @click="check"
        >
            <zoe-atom-text
                :item="answer.label.value"
            />
        </button>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import {
    addExtraData,
    getExtraData,
    getQuestionName,
    questionProps,
    storeExtraData,
} from '../../../../../mixins/quiz/v2.0.0/question';

import ZoeAtomText from '../../../../atoms/text/v1.0.0/zoe-atom-text.vue';
import { checkCompleted } from '../../../../../mixins/quiz/v2.0.0/checks';
import { getNextQuestion } from '../../../../../mixins/quiz/v2.0.0/get-next-question';

import { generateIndividualButtonVariables } from '../../../../../mixins/styling/styling';
import stripHtml from '../../../../../mixins/utils/strip-html';
import { getText } from '../../../../../../../resources/frontend/js/mixins/get-page-data';

const store = useStore();
const props = defineProps(questionProps);

const name = getQuestionName(props);
const uuid = ref(props.content?._info?.uuid);

onMounted(() => {
    addExtraData(name, {
        name,
        value: '',
        mask: '',
        validator: '',
        uuid: uuid.value,
        sendData: props.content.send_to_lead_service?.value !== false,
    });

    storeExtraData(name, 'question', stripHtml(props.content.text.value));
});

const check = event => {
    const answer = event.target;
    const questionWrapper = answer.closest('.question');
    const buttons = questionWrapper.querySelectorAll('.button');
    const delay = questionWrapper.dataset.delay ? parseInt(questionWrapper.dataset.delay) : 0;

    if (answer.dataset.showstopper !== '' && answer.dataset.showstopper !== 'none') {
        if (answer.dataset.hideShowstopperCloseButton === 'true') store.commit('dialog/preventClose');
        store.commit('dialog/show', event.target.dataset.showstopper);
        return;
    }

    answer.dataset.selected = 'true';

    const answerValue = answer.value;
    const linkedFormInputIdentifier = answer.dataset.linkedFormInput;
    const worktypeId = answer.dataset.worktypeId;
    const enquiryDashboardRedirectVersion = answer.dataset.enquiryDashboardRedirectVersion;
    const nextQuestion = getNextQuestion(answer.dataset.questionTo || '', store.state.quiz.currentQuestion);

    checkCompleted(name, buttons, props.preHook, nextQuestion, props.afterHook, answerValue, linkedFormInputIdentifier, worktypeId, enquiryDashboardRedirectVersion, delay);

    storeExtraData(name, 'value', answerValue);
    storeExtraData(name, 'label', answer.dataset.label);
};
</script>

<style lang="scss">
@use 'zoe-quiz-buttons';
</style>
